<template>
  <v-col>
    <v-row class="ma-0 align-center">
      <!-- Back Button (visible when on profile/detail view) -->
      <v-col
        v-if="!showDashboard"
        class="col-auto py-0 pr-2"
      >
        <v-btn
          icon
          x-small
          class="back-btn"
          title="Go back"
          aria-label="Go back"
          @click="goBack"
        >
          <font-awesome-icon
            :icon="['fas', 'arrow-left']"
            size="sm"
            class="gray--text"
          />
        </v-btn>
      </v-col>

      <v-col class="col-auto py-0">
        <span
          v-if="showDashboard"
          class="subtitle-2"
        >{{ dashboardTitle }}</span>

        <span
          v-else
          class="subtitle-2 primary--text cursor-pointer"
          @click="goToDashboard"
        >{{ dashboardTitle }}</span>
      </v-col>

      <!-- Parent breadcrumb (e.g., Client Name for project profiles) -->
      <template v-if="!showDashboard && parentName">
        <v-col class="col-auto py-0 px-0">
          <font-awesome-icon
            :icon="['fas', 'chevron-right']"
            class="gray--text"
            style="font-size: 9px; margin-bottom: 1px;"
          />
        </v-col>

        <v-col class="col-auto py-0">
          <router-link
            v-if="parentHref"
            :to="parentHref"
            class="subtitle-2 primary--text text-decoration-none"
          >
            {{ parentName }}
          </router-link>
          <span
            v-else
            class="subtitle-2"
          >{{ parentName }}</span>
        </v-col>
      </template>

      <v-col
        v-if="!showDashboard"
        class="col-auto py-0 px-0"
      >
        <font-awesome-icon
          :icon="['fas', 'chevron-right']"
          class="gray--text"
          style="font-size: 9px; margin-bottom: 1px;"
        />
      </v-col>

      <v-col
        v-if="!showDashboard"
        class="col-auto py-0"
      >
        <span class="subtitle-2">{{ objectTitle }}</span>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import { titlecase } from 'src/utils/format'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')
const { mapState: mapToolsState } = createNamespacedHelpers('tools')

export default {
  name: 'BreadCrumbs',
  data() {
    return {
      actions: [
        {
          event: 'delivery/openTabToLineItem',
          name: 'Go to Line Item',
        },
        {
          event: 'delivery/openTabToOrder',
          name: 'Go to Order',
        },
        {
          event: 'delivery/showCreativesDiscrepancyModal',
          name: 'Creatives Discrepancy',
        },
      ],
    }
  },
  computed: {
    ...mapAuthGetters([
      'inDarkMode',
    ]),
    ...mapToolsState({
      selectedSearch: (state) => state.selectedSearch,
    }),
    showDashboard() {
      // Check URL params first — delivery views (Pacing, Discrepancy) use query params
      if (this.$route.query.billingCode || this.$route.params.reportId) {
        return false
      }
      return this.selectedSearch?.dataType === 'custom'
    },
    dashboardTitle() {
      const reportKey = this.selectedSearch?.reportKey || ''
      return titlecase(reportKey.replace(/-/g, ' '))
    },
    objectTitle() {
      return this.selectedSearch?.text || ''
    },
    parentName() {
      return this.selectedSearch?.parentName || null
    },
    parentHref() {
      return this.selectedSearch?.parentHref || null
    },
  },
  methods: {
    getDashboardPath() {
      const { name: routeName, params } = this.$route
      const { reportName } = params
      const isReportDashboard = ['admin', 'internal', 'reports', 'settings'].includes(routeName)
      const dashboardMap = {
        dashboard: '/',
      }

      return dashboardMap[reportName] || (isReportDashboard ? `/${routeName}/${reportName}` : `/${routeName}`)
    },
    goToDashboard() {
      const path = this.getDashboardPath()

      this.$router.push({ path })
    },
    goBack() {
      const hasHistory = typeof window !== 'undefined' && window.history.length > 1

      if (hasHistory) {
        this.$router.go(-1)
        return
      }

      const path = this.getDashboardPath()
      this.$router.push({ path })
    },
  },
}
</script>
